const types = {
    TICKET_READER_FAILED: "TICKET_READER_FAILED",
    TICKET_READER_REQUEST: "TICKET_READER_REQUEST",
    TICKET_READER_SUCCESS: "TICKET_READER_SUCCESS",
};

export default types;
